export class PhysicalInventoryDetailModel {
  physicalInventoryDetailId: number = 0;
  physicalInventoryId: number = 0;
  articleId: number = 0;
  constructionSiteQuantity: number = 0;
  storeQuantity: number = 0;
  swCount1: boolean = false;
  swCount2: boolean = false;
  swCount3: boolean = false;
  swFinalCount: boolean = false;
  physicalQuantity1: number = 0;
  physicalQuantity2: number = 0;
  physicalQuantity3: number = 0;
  physicalQuantityFinal: number = 0;
  initialUnitCost: number = 0;
  finalUnitCost: number = 0;
  cardNumber: number | null = null;
  observation: string | null = null;
  workshopQuantity: number = 0;
  availableQuantity: number = 0;
  createDate: Date = new Date();
  userNameCreate: string = '';
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
